import React, { useEffect, useState } from "react";
import { setKey, setLanguage, fromLatLng } from "react-geocode";
import "../../../../styles/attendance/checkin-checkout-img.css";
import { convertTo12HourFormat } from "../../../common-data/Converts";
import { getGoogleMapsLink } from "../../../common-data/Geocodes";
import { GOOGLE_API_KEY } from "../../../../data/BaseUrl";

setKey(GOOGLE_API_KEY);
setLanguage("en");

const CheckinCheckoutImg = ({ rowData, modName }) => {
  const shift = rowData?.shift_details?.[0];
  const attendance = shift?.attendance_details || {};

  const [checkinAddress, setCheckinAddress] = useState("");
  const [checkoutAddress, setCheckoutAddress] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchAddresses = async () => {
      setLoading(true);
      try {
        if (
          modName === "checkin_image" &&
          attendance.checkin_lat &&
          attendance.checkin_long
        ) {
          const res = await fromLatLng(
            attendance.checkin_lat,
            attendance.checkin_long
          );
          setCheckinAddress(res.results[0]?.formatted_address || "");
        }
        if (
          modName === "checkout_image" &&
          attendance.checkout_lat &&
          attendance.checkout_long
        ) {
          const res = await fromLatLng(
            attendance.checkout_lat,
            attendance.checkout_long
          );
          setCheckoutAddress(res.results[0]?.formatted_address || "");
        }
      } catch (err) {
        setCheckinAddress("");
        setCheckoutAddress("");
      } finally {
        setLoading(false);
      }
    };
    fetchAddresses();
  }, [
    modName,
    attendance.checkin_lat,
    attendance.checkin_long,
    attendance.checkout_lat,
    attendance.checkout_long,
  ]);

  const renderTime = (label, time) =>
    time ? (
      <div className="checkin-time">
        <b>{label}:</b> {time ? convertTo12HourFormat(time) : "-"}
      </div>
    ) : null;

  const renderImageBlock = (type) => {
    const image =
      type === "checkin" ? attendance.checkin_image : attendance.checkout_image;
    const alt = type === "checkin" ? "Check-in" : "Check-out";

    return (
      <div className="modern-img-block">
        {image ? (
          <img src={image} alt={alt} className="modern-checkin-img" />
        ) : (
          <div className="modern-img-placeholder">No Image</div>
        )}
      </div>
    );
  };

  const renderInfoBlock = (type) => {
    const lat =
      type === "checkin" ? attendance.checkin_lat : attendance.checkout_lat;
    const lng =
      type === "checkin" ? attendance.checkin_long : attendance.checkout_long;
    const address = type === "checkin" ? checkinAddress : checkoutAddress;
    const time =
      type === "checkin" ? attendance.checkin_time : attendance.checkout_time;
    const timeLabel = type === "checkin" ? "Check-in Time" : "Check-out Time";

    return (
      <div className="modern-info-block">
        <div className="modern-info-row">
          <span className="modern-label">Latitude:</span>
          <span>{lat || "-"}</span>
        </div>
        <div className="modern-info-row">
          <span className="modern-label">Longitude:</span>
          <span>{lng || "-"}</span>
        </div>
        <div className="modern-info-row">
          <span className="modern-label">Gym Name:</span>
          <span>{rowData?.gym_name || "-"}</span>
        </div>
        <div className="modern-info-row modern-info-row-address">
          <span className="modern-label">
            {modName === "checkin_image" ? "Check-in" : "Check-out:"} Address
          </span>
          <span className="modern-address">
            {loading ? "Loading..." : address || "-"}
          </span>
        </div>
        {renderTime(timeLabel, time)}
        {lat && lng && (
          <a
            href={getGoogleMapsLink(lat, lng)}
            target="_blank"
            rel="noopener noreferrer"
            className="modern-map-btn">
            <span role="img" aria-label="map-pin" style={{ marginRight: 6 }}>
              📍
            </span>
            View on Google Maps
          </a>
        )}
      </div>
    );
  };

  const renderDetails = () => {
    if (
      modName === "checkout_image" &&
      (!attendance.checkout_lat || !attendance.checkout_long)
    ) {
      return (
        <div className="checkin-checkout-card modern-card">
          <div className="modern-info-flex-row">
            <div className="modern-img-placeholder">
              No Checkout Details Available
            </div>
          </div>
        </div>
      );
    }

    const type = modName === "checkin_image" ? "checkin" : "checkout";

    return (
      <div className="checkin-checkout-card modern-card">
        <div className="modern-info-flex-row">
          {renderImageBlock(type)}
          {renderInfoBlock(type)}
        </div>
      </div>
    );
  };

  return (
    <div className="checkin-checkout-container modern-bg">
      {renderDetails()}
    </div>
  );
};

export default CheckinCheckoutImg;
